(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["understory-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('us-footer-reference')) {
    customElements.define('us-footer-reference', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const newsletter = this.querySelector('.us-footer-reference__form');
        if (newsletter) this.setupNewsletter(newsletter, signal);

        this.desktop = window.matchMedia('(min-width: 1024px)');
        this.sync = () => {
          for (const details of this.querySelectorAll('details')) {
            details.open = this.desktop.matches;
            const summary = details.querySelector('summary');
            if (this.desktop.matches) summary.setAttribute('tabindex', '-1');
            else summary.removeAttribute('tabindex');
          }
        };
        this.sync();
        this.desktop.addEventListener('change', this.sync, { signal });
        this.addEventListener('click', event => {
          const summary = event.target.closest('summary');
          if (summary && this.contains(summary) && this.desktop.matches) event.preventDefault();
        }, { signal });
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape' && !this.desktop.matches) {
            const details = event.target.closest('details');
            if (details?.open) { details.open = false; details.querySelector('summary').focus(); }
          }
        }, { signal });
      }
      setupNewsletter(form, signal) {
        const email = form.querySelector('input[type="email"]');
        const button = form.querySelector('button[type="submit"]');
        const success = form.querySelector('[data-newsletter-success]');
        const error = form.querySelector('[data-newsletter-error]');
        let pending = false;
        let subscribed = !success.hidden;
        form.addEventListener('submit', async event => {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (pending || subscribed || !form.checkValidity()) return;
          pending = true;
          button.disabled = true;
          form.setAttribute('aria-busy', 'true');
          error.hidden = true;
          success.hidden = true;
          email.removeAttribute('aria-invalid');
          const request = new AbortController();
          const abort = () => request.abort();
          signal.addEventListener('abort', abort, { once: true });
          const timeout = setTimeout(abort, 30000);
          try {
            const action = new URL(form.action, window.location.origin);
            action.hash = '';
            const response = await fetch(action.href, {
              method: 'POST', body: new FormData(form), credentials: 'same-origin',
              headers: { Accept: 'text/html' }, signal: request.signal
            });
            const html = await response.text();
            const result = new DOMParser().parseFromString(html, 'text/html');
            // Shopify's bot check can only be passed on its own page: submit normally so the visitor sees it.
            if (response.headers.get('cf-mitigated') === 'challenge'
                || result.querySelector('script[src*="/cdn-cgi/challenge-platform/"]')
                || /verifying your connection|captcha|challenge/i.test(result.title)
                || new URL(response.url).pathname === '/challenge') {
              HTMLFormElement.prototype.submit.call(form);
              return;
            }
            const returnedForm = result.getElementById(form.id);
            const returnedError = returnedForm?.querySelector('[data-newsletter-error]:not([hidden])');
            if (returnedError) {
              email.setAttribute('aria-invalid', 'true');
              throw new Error(returnedError.textContent.trim() || error.dataset.msgCheckEmail);
            }
            const confirmed = returnedForm?.querySelector('[data-newsletter-success]:not([hidden])')
              || new URL(response.url).searchParams.get('customer_posted') === 'true';
            if (!response.ok || !confirmed) throw new Error(error.dataset.msgUnconfirmed);
            if (signal.aborted) return;
            subscribed = true;
            button.setAttribute('data-subscribed', '');
            success.hidden = false;
            email.setAttribute('aria-describedby', 'UsEmailConsent-' + email.id.slice(8) + ' ' + success.id);
          } catch (failure) {
            if (signal.aborted) return;
            error.textContent = failure.name === 'AbortError'
              ? error.dataset.msgTimeout : failure.message;
            error.hidden = false;
            email.setAttribute('aria-describedby', 'UsEmailConsent-' + email.id.slice(8) + ' ' + error.id);
          } finally {
            clearTimeout(timeout);
            signal.removeEventListener('abort', abort);
            pending = false;
            form.removeAttribute('aria-busy');
            button.disabled = subscribed;
          }
        }, { capture: true, signal });
      }
      disconnectedCallback() {
        this.controller?.abort(); this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["us-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('us-banner-slider')) {
    customElements.define('us-banner-slider', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const on = (node, type, handler, options = {}) => node?.addEventListener(type, handler, { ...options, signal: this.abort.signal });
        this.track = this.querySelector('[data-track]');
        this.viewport = this.querySelector('[data-viewport]');
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.dots = [...this.querySelectorAll('[data-dot]')];
        this.captions = [...this.querySelectorAll('[data-caption]')];
        this.index = 0; this.hovered = false; this.swipe = null; this.suppressClickUntil = 0;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.dataset.autoplay !== 'true' || this.reduced.matches || Boolean(window.Shopify?.designMode);
        if (!this.slides.length) return;
        if (this.slides.length > 1) {
          this.querySelector('[data-controls]').hidden = false;
          const play = this.querySelector('[data-play]');
          if (play) play.hidden = false;
        }
        this.dots.forEach((dot, index) => on(dot, 'click', () => this.show(index, true)));
        on(this.querySelector('[data-play]'), 'click', () => { this.paused = !this.paused; this.schedule(); });
        on(this, 'mouseenter', () => { this.hovered = true; this.schedule(); });
        on(this, 'mouseleave', () => { this.hovered = false; this.schedule(); });
        on(this, 'focusin', event => { if (!event.target.matches('[data-play]')) { this.paused = true; this.schedule(); } });
        on(document, 'visibilitychange', () => this.schedule());
        on(this.reduced, 'change', () => { if (this.reduced.matches) this.paused = true; this.schedule(); });
        on(this, 'keydown', event => {
          if (event.target.matches('input, textarea, select')) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault(); this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
          }
        });
        on(this.viewport, 'pointerdown', event => {
          if (event.pointerType !== 'mouse') this.swipe = { x: event.clientX, y: event.clientY, id: event.pointerId };
        });
        on(this.viewport, 'pointercancel', () => { this.swipe = null; });
        on(this.viewport, 'pointerup', event => {
          if (!this.swipe || this.swipe.id !== event.pointerId) return;
          const dx = event.clientX - this.swipe.x, dy = event.clientY - this.swipe.y;
          this.swipe = null;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) {
            this.suppressClickUntil = Date.now() + 500;
            this.show(this.index + (dx < 0 ? 1 : -1), true);
          }
        });
        on(this.viewport, 'click', event => {
          if (Date.now() < this.suppressClickUntil) { event.preventDefault(); event.stopPropagation(); }
        }, { capture: true });
        on(document, 'shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.block === event.detail?.blockId);
          if (index >= 0) this.show(index, true);
        });
        this.show(0, false);
      }
      show(index, manual = false) {
        if (!this.slides.length) return;
        const previous = this.slides[this.index];
        const moveFocus = manual && previous?.contains(document.activeElement);
        this.index = ((index % this.slides.length) + this.slides.length) % this.slides.length;
        this.track.style.transform = `translateX(-${this.index * 100}%)`;
        const active = this.slides[this.index];
        this.viewport.style.setProperty('--desktop-ratio', active.dataset.desktopRatio);
        this.viewport.style.setProperty('--mobile-ratio', active.dataset.mobileRatio);
        this.slides.forEach((slide, i) => {
          slide.inert = i !== this.index;
          if (i === this.index) slide.removeAttribute('aria-hidden'); else slide.setAttribute('aria-hidden', 'true');
        });
        this.dots.forEach((dot, i) => {
          dot.classList.toggle('active', i === this.index);
          if (i === this.index) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
        });
        this.captions.forEach((caption, i) => { caption.hidden = i !== this.index; });
        if (moveFocus) {
          const target = active.querySelector('a') || this.dots[this.index];
          target?.focus({ preventScroll: true });
        }
        if (manual) {
          this.paused = true;
          const status = this.querySelector('[data-status]');
          if (status) status.textContent = this.dataset.statusLabel.replace('[index]', this.index + 1).replace('[length]', this.slides.length);
        }
        this.schedule();
      }
      schedule() {
        clearTimeout(this.timer);
        const play = this.querySelector('[data-play]');
        if (play) play.textContent = this.paused ? this.dataset.playLabel : this.dataset.pauseLabel;
        if (!this.paused && !this.hovered && !this.reduced.matches && !document.hidden && this.slides.length > 1) {
          this.timer = setTimeout(() => this.show(this.index + 1), Math.max(3000, Number(this.dataset.interval) || 10000));
        }
      }
      disconnectedCallback() { clearTimeout(this.timer); this.abort?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["us-bestsellers"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('us-bestsellers')) {
    customElements.define('us-bestsellers', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.viewport = this.querySelector('.us-bs__viewport');
        this.track = this.querySelector('.us-bs__track');
        this.slides = [...this.querySelectorAll('.us-bs__slide')];
        this.dots = this.querySelector('.us-bs__dots');
        this.status = this.querySelector('.us-bs__status');
        if (!this.viewport || !this.slides.length) return;
        this.updateLayout = () => {
          this.stride = this.slides[0].getBoundingClientRect().width;
          if (!this.stride) return;
          this.visible = Math.max(1, Math.round(this.track.clientWidth / this.stride));
          this.last = Math.max(0, this.slides.length - this.visible);
          this.rtl = getComputedStyle(this.viewport).direction === 'rtl';
          this.dots.replaceChildren();
          for (let i = 0; i <= this.last; i++) {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'us-bs__dot';
            dot.setAttribute('aria-label', this.dataset.dotLabel.replace('[index]', i + 1));
            dot.addEventListener('click', () => this.go(i, true));
            this.dots.append(dot);
          }
          this.dots.hidden = this.last === 0;
          this.updateDots();
        };
        this.updateDots = () => {
          this.index = Math.min(this.last, Math.max(0, Math.round(Math.abs(this.viewport.scrollLeft) / this.stride)));
          [...this.dots.children].forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.index)));
        };
        this.viewport.addEventListener('scroll', this.updateDots, { ...options, passive: true });
        this.viewport.addEventListener('keydown', event => {
          if (event.target !== this.viewport) return;
          let next;
          if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.last;
          else if (event.key === 'ArrowRight') next = this.index + (this.rtl ? -1 : 1);
          else if (event.key === 'ArrowLeft') next = this.index + (this.rtl ? 1 : -1);
          else return;
          event.preventDefault();
          this.go(next, true);
        }, options);
        this.viewport.addEventListener('pointerdown', event => {
          if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('button, input, form')) return;
          this.drag = { id: event.pointerId, x: event.clientX, scroll: this.viewport.scrollLeft, moved: false };
        }, options);
        this.viewport.addEventListener('pointermove', event => {
          if (!this.drag || this.drag.id !== event.pointerId) return;
          const delta = event.clientX - this.drag.x;
          if (Math.abs(delta) > 6 && !this.drag.moved) {
            this.drag.moved = true;
            this.viewport.setPointerCapture(event.pointerId);
            this.setAttribute('data-dragging', '');
          }
          if (this.drag.moved) { event.preventDefault(); this.viewport.scrollLeft = this.drag.scroll - delta; }
        }, options);
        const endDrag = event => {
          if (!this.drag || event.pointerId !== this.drag.id) return;
          if (this.drag.moved) {
            this.suppressClick = true;
            clearTimeout(this.clickTimer);
            this.clickTimer = setTimeout(() => { this.suppressClick = false; }, 0);
            if (this.viewport.hasPointerCapture(event.pointerId)) this.viewport.releasePointerCapture(event.pointerId);
          }
          this.drag = null;
          this.removeAttribute('data-dragging');
        };
        window.addEventListener('pointerup', endDrag, options);
        window.addEventListener('pointercancel', endDrag, options);
        this.viewport.addEventListener('dragstart', event => event.preventDefault(), options);
        this.viewport.addEventListener('click', event => { if (this.suppressClick) { event.preventDefault(); event.stopPropagation(); } }, { ...options, capture: true });
        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(this.updateLayout);
          this.observer.observe(this.viewport);
        } else window.addEventListener('resize', this.updateLayout, options);
        document.addEventListener('shopify:block:select', event => {
          if (!this.contains(event.target)) return;
          const index = this.slides.indexOf(event.target.closest('.us-bs__slide'));
          if (index >= 0) this.go(index, false);
        }, options);
        this.updateLayout();
      }
      go(index, announce) {
        const target = Math.max(0, Math.min(this.last, index));
        this.viewport.scrollTo({ left: target * this.stride * (this.rtl ? -1 : 1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        if (announce) this.status.textContent = this.dataset.statusLabel.replace('[first]', target + 1).replace('[last]', Math.min(this.slides.length, target + this.visible)).replace('[total]', this.slides.length);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        clearTimeout(this.clickTimer);
        this.drag = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["us-featured-in"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('us-featured-in')) {
    customElements.define('us-featured-in', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const viewport = this.querySelector('.us-featured-in__viewport');
        if (!viewport) return;
        const resize = () => this.style.setProperty('--us-featured-width', `${viewport.clientWidth}px`);
        resize();
        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(resize);
          this.observer.observe(viewport);
        } else window.addEventListener('resize', resize, options);
        // Duplicates must not repeat Shopify's editor block attributes.
        this.querySelectorAll('.us-featured-in__duplicate [data-shopify-editor-block]').forEach(el => el.removeAttribute('data-shopify-editor-block'));
        const button = this.querySelector('.us-featured-in__pause');
        button?.addEventListener('click', () => {
          const paused = this.toggleAttribute('data-paused');
          button.setAttribute('aria-pressed', String(paused));
          button.textContent = paused ? this.dataset.resumeLabel : this.dataset.pauseLabel;
        }, options);
        const visibility = () => this.toggleAttribute('data-background', document.hidden);
        document.addEventListener('visibilitychange', visibility, options);
        visibility();
        this.setAttribute('data-ready', '');
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.removeAttribute('data-ready');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["us-photo-testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('us-photo-testimonials')) {
    customElements.define('us-photo-testimonials', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const on = (node, event, handler) => node?.addEventListener(event, handler, { signal: this.abort.signal });
        this.track = this.querySelector('.us-photo-reviews__track');
        this.cards = [...this.querySelectorAll('[data-review]')];
        this.dots = this.querySelector('[data-dots]');
        this.status = this.querySelector('[data-status]');
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.drag = null;
        this.page = 0;
        this.pageCount = 0;
        this.rtl = getComputedStyle(this.track).direction === 'rtl';
        this.updatePages();

        on(this.dots, 'click', (event) => {
          const dot = event.target.closest('[data-page]');
          if (dot && this.dots.contains(dot)) this.go(Number(dot.dataset.page), true);
        });
        on(this.track, 'scroll', () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = null; this.updateCurrent(); });
        });
        on(this.track, 'keydown', (event) => {
          if (event.target !== this.track) return;
          if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.go(event.key === 'Home' ? 0 : this.pageCount - 1, true);
          } else if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            const step = (event.key === 'ArrowRight' ? 1 : -1) * (this.rtl ? -1 : 1);
            this.go((this.page + step + this.pageCount) % this.pageCount, true);
          }
        });
        on(this.track, 'dragstart', (event) => event.preventDefault());
        on(this.track, 'pointerdown', (event) => {
          if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('a, button')) return;
          this.drag = { id: event.pointerId, x: event.clientX, scroll: this.track.scrollLeft, moved: false };
          this.track.setPointerCapture(event.pointerId);
        });
        on(this.track, 'pointermove', (event) => {
          if (!this.drag || this.drag.id !== event.pointerId) return;
          const distance = event.clientX - this.drag.x;
          if (Math.abs(distance) > 5) this.drag.moved = true;
          if (!this.drag.moved) return;
          event.preventDefault();
          this.track.dataset.dragging = '';
          this.track.style.userSelect = 'none';
          this.track.scrollLeft = this.drag.scroll - distance;
        });
        const stopDrag = () => {
          const moved = this.drag?.moved;
          this.drag = null;
          delete this.track.dataset.dragging;
          this.track.style.removeProperty('user-select');
          if (moved) {
            this.updateCurrent();
            this.go(this.page, true);
          }
        };
        on(this.track, 'pointerup', stopDrag);
        on(this.track, 'pointercancel', stopDrag);
        on(this.track, 'lostpointercapture', stopDrag);
        on(document, 'shopify:block:select', (event) => {
          const card = this.cards.find((item) => item === event.target || item.contains(event.target));
          if (!card) return;
          this.go(Math.floor(this.cards.indexOf(card) / this.columns), false, true);
        });
        this.resize = new ResizeObserver(() => this.updatePages());
        this.resize.observe(this.track);

      }
      updatePages() {
        const previousColumns = this.columns;
        this.columns = Number(getComputedStyle(this.track).getPropertyValue('--us-photo-columns')) || 1;
        const count = Math.max(1, Math.ceil(this.cards.length / this.columns));
        if (count !== this.pageCount) {
          this.pageCount = count;
          this.dots.replaceChildren();
          if (count > 1) {
            for (let index = 0; index < count; index++) {
              const button = document.createElement('button');
              button.type = 'button';
              button.className = 'us-photo-reviews__dot';
              button.dataset.page = String(index);
              button.setAttribute('aria-label', this.dataset.dotLabel.replace('[index]', index + 1).replace('[total]', count));
              button.setAttribute('aria-controls', this.track.id);
              this.dots.append(button);
            }
          }
        }
        this.dots.hidden = count <= 1;
        const sign = this.rtl ? -1 : 1;
        const current = this.track.scrollLeft * sign;
        const bounds = this.track.getBoundingClientRect();
        const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        // Cards come to rest after the track's side padding, not at its edge.
        const inset = parseFloat(getComputedStyle(this.track).paddingInlineStart) || 0;
        this.positions = Array.from({ length: count }, (_, index) => {
          const card = this.cards[index * this.columns];
          if (!card) return 0;
          const box = card.getBoundingClientRect();
          const offset = (this.rtl ? bounds.right - box.right : box.left - bounds.left) - inset;
          return Math.max(0, Math.min(maximum, current + offset));
        });
        this.updateCurrent();
        if (previousColumns && previousColumns !== this.columns) this.go(this.page, false, true);
      }
      updateCurrent() {
        const position = this.track.scrollLeft * (this.rtl ? -1 : 1);
        this.page = this.positions.reduce((best, target, index) =>
          Math.abs(target - position) < Math.abs(this.positions[best] - position) ? index : best, 0);
        [...this.dots.children].forEach((dot, index) => {
          if (index === this.page) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }
      go(page, announce, instant = false) {
        page = Math.max(0, Math.min(this.pageCount - 1, page));
        this.track.scrollTo({
          left: this.positions[page] * (this.rtl ? -1 : 1),
          behavior: instant || this.reduced.matches ? 'instant' : 'smooth'
        });
        if (announce) this.status.textContent = this.dataset.statusLabel.replace('[index]', page + 1).replace('[total]', this.pageCount);
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.resize?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = null;
        if (this.track) {
          delete this.track.dataset.dragging;
          this.track.style.removeProperty('user-select');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["us-signup-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('us-signup-popup')) {
    customElements.define('us-signup-popup', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;
        this.querySelector('[data-popup-close]')?.addEventListener('click', () => this.dialog.close(), { signal });
        this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); }, { signal });
        this.dialog.addEventListener('close', () => this.#closed(), { signal });
        const form = this.querySelector('form');
        if (form) this.#setupForm(form, signal);
        document.addEventListener('shopify:section:select', event => { if (this.closest('.shopify-section')?.contains(event.target)) this.#open(); }, { signal });
        document.addEventListener('shopify:section:deselect', event => { if (this.closest('.shopify-section')?.contains(event.target)) this.dialog.close(); }, { signal });
        // A no-JavaScript submit reloads the page: show its result straight away.
        if (this.querySelector('[data-popup-success]:not([hidden]), [data-popup-error]:not([hidden])')) { this.#open(); return; }
        if (window.Shopify?.designMode || this.#seen()) return;
        this.#schedule(Number(this.dataset.delay || 8) * 1000);
      }
      disconnectedCallback() {
        this.controller?.abort();
        clearTimeout(this.timer);
      }
      #schedule(delay) {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.#open(), delay);
      }
      #seen() {
        try { return localStorage.getItem(this.dataset.storageKey) !== null; } catch { return false; }
      }
      #remember() {
        try { localStorage.setItem(this.dataset.storageKey, String(Date.now())); } catch { /* storage blocked: shows again next visit */ }
      }
      #open() {
        if (this.dialog.open) return;
        // Don't stack on top of the cart drawer or another dialog; try again a little later.
        if (document.querySelector('dialog[open]')) { this.#schedule(5000); return; }
        this.returnFocus = document.activeElement;
        this.dialog.showModal();
      }
      #closed() {
        this.#remember();
        if (this.returnFocus instanceof HTMLElement && this.returnFocus.isConnected) this.returnFocus.focus({ preventScroll: true });
        this.returnFocus = null;
      }
      #setupForm(form, signal) {
        const email = form.querySelector('input[type="email"]');
        const button = form.querySelector('button[type="submit"]');
        const success = form.querySelector('[data-popup-success]');
        const error = form.querySelector('[data-popup-error]');
        let pending = false;
        form.addEventListener('submit', async event => {
          event.preventDefault();
          if (pending || !form.checkValidity()) return;
          pending = true;
          button.disabled = true;
          form.setAttribute('aria-busy', 'true');
          error.hidden = true;
          email.removeAttribute('aria-invalid');
          const request = new AbortController();
          const timeout = setTimeout(() => request.abort(), 30000);
          signal.addEventListener('abort', () => request.abort(), { once: true });
          try {
            const action = new URL(form.action, window.location.origin);
            action.hash = '';
            const response = await fetch(action.href, {
              method: 'POST', body: new FormData(form), credentials: 'same-origin',
              headers: { Accept: 'text/html' }, signal: request.signal
            });
            const result = new DOMParser().parseFromString(await response.text(), 'text/html');
            // Shopify's bot check can only be passed on its own page: submit normally so the visitor sees it.
            if (response.headers.get('cf-mitigated') === 'challenge'
                || result.querySelector('script[src*="/cdn-cgi/challenge-platform/"]')
                || /verifying your connection|captcha|challenge/i.test(result.title)
                || new URL(response.url).pathname === '/challenge') {
              this.#remember();
              HTMLFormElement.prototype.submit.call(form);
              return;
            }
            const returned = result.getElementById(form.id);
            const returnedError = returned?.querySelector('[data-popup-error]:not([hidden])');
            if (returnedError) {
              email.setAttribute('aria-invalid', 'true');
              throw new Error(returnedError.textContent.trim() || error.dataset.msgCheckEmail);
            }
            const confirmed = returned?.querySelector('[data-popup-success]:not([hidden])')
              || new URL(response.url).searchParams.get('customer_posted') === 'true';
            if (!response.ok || !confirmed) throw new Error(error.dataset.msgUnconfirmed);
            success.hidden = false;
            this.#remember();
          } catch (failure) {
            if (signal.aborted) return;
            error.textContent = failure.name === 'AbortError' ? error.dataset.msgTimeout : failure.message;
            error.hidden = false;
            button.disabled = false;
          } finally {
            clearTimeout(timeout);
            pending = false;
            form.removeAttribute('aria-busy');
          }
        }, { signal });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["us-testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('us-testimonials')) {
    customElements.define(
      'us-testimonials',
      class extends HTMLElement {
        connectedCallback() {
          this.abort?.abort();
          this.abort = new AbortController();

          const on = (target, event, handler) => {
            target?.addEventListener(event, handler, {
              signal: this.abort.signal
            });
          };

          this.track = this.querySelector('.us-testimonials__track');

          this.querySelectorAll('[data-more]').forEach((button) => {
            const card = button.closest('[data-review]');

            card.querySelector('[data-full]').hidden = true;
            card.querySelector('[data-short]').hidden = false;
            button.hidden = false;
            button.setAttribute('aria-expanded', 'false');
            button.textContent = this.dataset.moreLabel;
          });

          on(this, 'click', (event) => {
            const button = event.target.closest('[data-more]');
            if (!button) return;

            const expanded =
              button.getAttribute('aria-expanded') === 'true';

            const card = button.closest('[data-review]');

            card.querySelector('[data-full]').hidden = expanded;
            card.querySelector('[data-short]').hidden = !expanded;

            button.setAttribute('aria-expanded', String(!expanded));
            button.textContent = expanded ? this.dataset.moreLabel : this.dataset.lessLabel;
          });

          const scroll = (direction) => {
            const rtl =
              getComputedStyle(this.track).direction === 'rtl';

            const reduce =
              matchMedia('(prefers-reduced-motion: reduce)').matches;

            const style = getComputedStyle(this.track);
            const page = this.track.clientWidth - parseFloat(style.paddingInlineStart) - parseFloat(style.paddingInlineEnd);

            this.track.scrollBy({
              left: direction * (rtl ? -1 : 1) * page,
              behavior: reduce ? 'auto' : 'smooth'
            });
          };

          on(this.querySelector('[data-prev]'), 'click', () => {
            scroll(-1);
          });

          on(this.querySelector('[data-next]'), 'click', () => {
            scroll(1);
          });

          on(this.track, 'keydown', (event) => {
            if (event.target !== this.track) return;

            if (
              event.key === 'ArrowRight' ||
              event.key === 'ArrowLeft'
            ) {
              event.preventDefault();

              const rtl =
                getComputedStyle(this.track).direction === 'rtl';

              scroll(
                (event.key === 'ArrowRight' ? 1 : -1) *
                (rtl ? -1 : 1)
              );
            }
          });

          const controls = this.querySelector('[data-controls]');

          if (controls && 'ResizeObserver' in window) {
            this.resizeObserver = new ResizeObserver(() => {
              controls.hidden =
                this.track.scrollWidth <= this.track.clientWidth + 1;
            });

            this.resizeObserver.observe(this.track);
          }

          on(document, 'shopify:block:select', (event) => {
            if (!this.contains(event.target)) return;

            event.target.scrollIntoView({
              behavior: 'auto',
              block: 'nearest',
              inline: 'nearest'
            });
          });

        }

        disconnectedCallback() {
          this.abort?.abort();
          this.resizeObserver?.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
